import api from "./api";

/** Evidence item in the shape the backend stores on a dispute. */
export interface RainEvidencePayload {
  type: string;
  description: string;
  source: string;
  timestamp: string;
  sha256_hash: string;
  fileName: string;
  youtubeUrl?: string;
  aiAnalysis?: string;
  analysisConfidence?: number;
  extractedText?: string;
  analysisSuccess?: boolean;
  cloudinaryUrl?: string;
  cloudinaryPublicId?: string;
  cloudinaryFormat?: string;
  fileSize?: number;
  tokenCost?: {
    model: string;
    inputTokens: number;
    outputTokens: number;
    totalTokens: number;
    totalCost: number;
  } | null;
}

export interface RainDecisionRequest {
  question: string;
  options: string[];
  statement_of_claim?: string;
  pool_creation_date?: string;
  ai_decision?: string;
  submitted_evidence?: RainEvidencePayload[];
}

export interface RainDecision {
  dispute_id?: string;
  dispute_category?: string;
  confidence_score?: number;
  selected_option?: number;
  finding_summary?: string;
  rules_applied?: string[];
  appealable?: boolean;
  gpt_analysis?: string;
  perplexity_analysis?: string;
  final_analysis_of_the_two_analyses?: string;
  [key: string]: unknown;
}

export interface RainDecisionResponse {
  decision?: RainDecision;
  [key: string]: unknown;
}

/**
 * Submit a Rain decision request. This is a long call (the backend runs
 * several AI agents and a final synthesis) - typically 20-60 seconds.
 */
export const submitRainDecision = async (
  payload: RainDecisionRequest
): Promise<RainDecisionResponse> => {
  const response = await api.post<RainDecisionResponse>(
    "/api/dispute/rain",
    payload,
    { timeout: 240000 }
  );
  return response.data;
};
